import { currentLanguage, switchLanguage, translations } from './translations.js';

// Interactive Command Line
export function initInteractiveCommandLine() {
	createNewCommandLine();
}

function createNewCommandLine() {
	const terminalContent = document.querySelector('.terminal-content');
	if (!terminalContent) return;

	// Available commands (description updates with current language)
	const commands = [
		{
			command: 'cmd',
			get description() {
				return currentLanguage === 'ru' ? 'Показать список доступных команд' : 'Show available commands';
			},
			action: () => showCommandsList(commands),
		},
		{
			command: 'lang --switch',
			get description() {
				return translations[currentLanguage].langSwitchDesc;
			},
			action: () => switchLanguage(),
		},
		{
			command: 'contact',
			get description() {
				return translations[currentLanguage].contactDesc;
			},
			action: () => window.contactFormModule.startContactForm(),
		},
	];

	// Create new command line
	const commandLineContainer = document.createElement('div');
	commandLineContainer.className = 'command-line';
	commandLineContainer.style.marginTop = '20px';

	const prompt = document.createElement('div');
	prompt.className = 'prompt';
	prompt.innerHTML = `
        <span class="user" style="color: var(--electric-blue);">nikita@portfolio</span>
        <span class="separator" style="color: var(--white);">:</span>
        <span class="path" style="color: var(--cyber-pink);">~</span>
        <span class="dollar" style="color: var(--neon-green); margin: 0 8px 0 4px;">$</span>
    `;

	// Create input field
	const input = document.createElement('input');
	input.type = 'text';
	input.className = 'command-input';
	input.autocomplete = 'new-password';
	input.autocapitalize = 'off';
	input.autocorrect = 'off';
	input.spellcheck = false;
	input.setAttribute('data-form-type', 'other');
	input.setAttribute('data-lpignore', 'true');
	input.name = 'cmd_' + Math.random().toString(36).substr(2, 9);
	input.setAttribute('readonly', 'readonly');
	setTimeout(() => input.removeAttribute('readonly'), 100);
	input.placeholder =
		currentLanguage === 'ru'
			? "Введите 'cmd' для списка команд..."
			: "Type 'cmd' for commands list...";
	input.style.cssText = `
        background: transparent;
        border: none;
        outline: none;
        color: var(--white);
        font-family: 'Fira Code', monospace;
        font-size: 14px;
        width: 200px;
        caret-color: var(--neon-green);
    `;

	// Create autocomplete dropdown
	const autocomplete = document.createElement('div');
	autocomplete.className = 'autocomplete-dropdown';
	autocomplete.style.cssText = `
        position: absolute;
        top: 100%;
        left: 0;
        background: var(--terminal-bg);
        border: 1px solid var(--neon-green);
        border-radius: 4px;
        max-height: 200px;
        overflow-y: auto;
        z-index: 1000;
        display: none;
        box-shadow: 0 4px 15px rgba(0, 255, 65, 0.3);
    `;

	// Create wrapper for input and autocomplete
	const inputWrapper = document.createElement('span');
	inputWrapper.style.position = 'relative';
	inputWrapper.style.display = 'inline-block';

	inputWrapper.appendChild(input);
	inputWrapper.appendChild(autocomplete);
	prompt.appendChild(inputWrapper);
	commandLineContainer.appendChild(prompt);

	// Remove old command line
	const oldCommandLine = terminalContent.querySelector('.command-line');
	if (oldCommandLine) {
		oldCommandLine.remove();
	}

	terminalContent.appendChild(commandLineContainer);

	// Input event handlers
	input.addEventListener('input', e => {
		const value = e.target.value.toLowerCase();
		showAutocomplete(value, commands, autocomplete, input);
	});

	input.addEventListener('keydown', e => {
		if (e.key === 'Enter') {
			const command = e.target.value.trim();
			if (command) {
				executeCommand(command, commands);
			}
		} else if (e.key === 'Escape') {
			hideAutocomplete(autocomplete);
		} else if (e.key === 'Tab') {
			e.preventDefault();
			const activeItem = autocomplete.querySelector(
				'.autocomplete-item.active'
			);
			if (activeItem) {
				e.target.value = activeItem.dataset.command;
				hideAutocomplete(autocomplete);
			}
		} else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
			e.preventDefault();
			navigateAutocomplete(autocomplete, e.key === 'ArrowDown' ? 1 : -1);
		}
	});

	// Hide autocomplete when clicking outside
	document.addEventListener('click', e => {
		if (!inputWrapper.contains(e.target)) {
			hideAutocomplete(autocomplete);
		}
	});

	// Focus input
	input.focus();

	// Scroll to bottom
	terminalContent.scrollTop = terminalContent.scrollHeight;
}

function showAutocomplete(value, commands, dropdown, input) {
	const filtered = commands.filter(
		cmd =>
			cmd.command.toLowerCase().includes(value) ||
			cmd.description.toLowerCase().includes(value)
	);

	if (filtered.length === 0 || value === '') {
		hideAutocomplete(dropdown);
		return;
	}

	dropdown.innerHTML = '';
	filtered.forEach((cmd, index) => {
		const item = document.createElement('div');
		item.className = 'autocomplete-item';
		if (index === 0) item.classList.add('active');
		item.dataset.command = cmd.command;
		item.style.cssText = `
            padding: 8px 12px;
            cursor: pointer;
            border-bottom: 1px solid rgba(0, 255, 65, 0.1);
            transition: background-color 0.3s;
        `;

		item.innerHTML = `
            <div style="color: var(--neon-green); font-weight: 600;">${cmd.command}</div>
            <div style="color: var(--white); font-size: 12px; opacity: 0.8;">${cmd.description}</div>
        `;

		item.addEventListener('mouseenter', () => {
			dropdown
				.querySelectorAll('.autocomplete-item')
				.forEach(i => i.classList.remove('active'));
			item.classList.add('active');
		});

		item.addEventListener('click', () => {
			input.value = cmd.command;
			hideAutocomplete(dropdown);
			input.focus();
		});

		dropdown.appendChild(item);
	});

	dropdown.style.display = 'block';
}

function hideAutocomplete(dropdown) {
	dropdown.style.display = 'none';
}

function navigateAutocomplete(dropdown, direction) {
	const items = dropdown.querySelectorAll('.autocomplete-item');
	const activeIndex = Array.from(items).findIndex(item =>
		item.classList.contains('active')
	);

	if (items.length === 0) return;

	items[activeIndex]?.classList.remove('active');

	let newIndex = activeIndex + direction;
	if (newIndex < 0) newIndex = items.length - 1;
	if (newIndex >= items.length) newIndex = 0;

	items[newIndex].classList.add('active');
}

function executeCommand(command, commands) {
	const cmd = commands.find(
		c => c.command.toLowerCase() === command.toLowerCase()
	);

	// Show executed command first
	showCommandExecution(command);

	if (cmd) {
		// Execute the command after showing it
		setTimeout(() => {
			cmd.action();
			// Create new command line after execution (except for contact command)
			if (cmd.command !== 'contact') {
				setTimeout(() => {
					createNewCommandLine();
				}, 300);
			}
		}, 100);
	} else if (command.trim() !== '') {
		// Show error and create new command line
		setTimeout(() => {
			const errorMsg = currentLanguage === 'ru' 
				? `Команда '${command}' не найдена. Введите 'cmd' для списка команд.`
				: `Command '${command}' not found. Type 'cmd' for commands list.`;
			showCommandError(errorMsg);
			createNewCommandLine();
		}, 100);
	}
}

function showCommandExecution(command) {
	const terminalContent = document.querySelector('.terminal-content');
	const executionDiv = document.createElement('div');
	executionDiv.style.marginTop = '10px';

	const promptLine = document.createElement('div');
	promptLine.innerHTML = `
        <span style="color: var(--electric-blue);">nikita@portfolio</span>
        <span style="color: var(--white);">:</span>
        <span style="color: var(--cyber-pink);">~</span>
        <span style="color: var(--neon-green);">$</span>
        <span style="color: var(--white); margin-left: 8px;">${command}</span>
    `;

	executionDiv.appendChild(promptLine);

	// Insert before the current command line
	const currentCommandLine = terminalContent.querySelector('.command-line');
	if (currentCommandLine) {
		terminalContent.insertBefore(executionDiv, currentCommandLine);
	} else {
		terminalContent.appendChild(executionDiv);
	}
}

function showCommandError(error) {
	const terminalContent = document.querySelector('.terminal-content');
	const errorDiv = document.createElement('div');
	errorDiv.style.cssText = `
        color: var(--cyber-pink);
        margin-top: 5px;
        margin-bottom: 10px;
    `;
	errorDiv.textContent = error;

	// Insert before the current command line
	const currentCommandLine = terminalContent.querySelector('.command-line');
	if (currentCommandLine) {
		terminalContent.insertBefore(errorDiv, currentCommandLine);
	} else {
		terminalContent.appendChild(errorDiv);
	}
}

function showCommandsList(commands) {
	const terminalContent = document.querySelector('.terminal-content');
	const commandsDiv = document.createElement('div');
	commandsDiv.style.cssText = `
        margin-top: 10px;
        margin-bottom: 15px;
        padding: 15px;
        border: 1px solid var(--neon-green);
        border-radius: 5px;
        background: rgba(0, 20, 20, 0.3);
    `;

	const title = currentLanguage === 'ru' ? 'Доступные команды:' : 'Available commands:';
	const titleDiv = document.createElement('div');
	titleDiv.style.cssText = `
        color: var(--neon-green);
        font-weight: 600;
        margin-bottom: 10px;
        font-size: 14px;
    `;
	titleDiv.textContent = title;
	commandsDiv.appendChild(titleDiv);

	commands.forEach(cmd => {
		const cmdDiv = document.createElement('div');
		cmdDiv.style.cssText = `
            margin: 8px 0;
            padding: 5px 0;
            border-bottom: 1px solid rgba(0, 255, 65, 0.2);
        `;
		
		cmdDiv.innerHTML = `
            <div style="color: var(--electric-blue); font-weight: 500; margin-bottom: 2px;">${cmd.command}</div>
            <div style="color: var(--white); font-size: 12px; opacity: 0.8; margin-left: 15px;">${cmd.description}</div>
        `;
		
		commandsDiv.appendChild(cmdDiv);
	});

	// Insert before the current command line
	const currentCommandLine = terminalContent.querySelector('.command-line');
	if (currentCommandLine) {
		terminalContent.insertBefore(commandsDiv, currentCommandLine);
	} else {
		terminalContent.appendChild(commandsDiv);
	}
}